var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('r-m-input-wrapper',{attrs:{"group":_vm.group}},[_c(_vm.group.name,{tag:"component",attrs:{"group":_vm.group},on:{"update:valid":function($event){return _vm.$emit('update:valid', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }